import { Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AddDealerRQ,
  CityModel,
  CityService,
  DealerService,
  GetDealerModelRQ,
  ListCityByStateRQ,
  RolesModel,
  RolesService,
  StateModel,
  StateService,
  UpdateDealerRQ,
  ListStateRQ
} from 'app/open-api';
import { NgxSpinnerService } from 'ngx-spinner';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-dealers-create',
  templateUrl: './dealers-create.component.html',
  styleUrls: ['./dealers-create.component.scss']
})
export class DealersCreateComponent implements OnInit {

  roles: RolesModel[] = [];
  states: StateModel[] = [];
  cities: CityModel[] = [];
  dealerId?: string;
  dealerForm: FormGroup;
  isEditMode = false;

  constructor(
    private location: Location,
    private roleService: RolesService,
    private stateService: StateService,
    private dealerService: DealerService,
    private cityService: CityService,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private router: Router
  ) {
    this.dealerId = this.route.snapshot.paramMap.get('dealerId');
    if (this.dealerId) {
      this.isEditMode = true;
    }
  }

  async ngOnInit(): Promise<void> {
    this.spinner.show();
    this.dealerForm = new FormGroup({
      roleId: new FormControl(null, Validators.required),
      stateId: new FormControl(null, Validators.required),
      cityId: new FormControl({ value: null, disabled: true }, Validators.required),
      name: new FormControl(null, Validators.required),
      userName: new FormControl(null, Validators.required),
      password: new FormControl(null, Validators.required),
      email: new FormControl(null, [Validators.required, Validators.email]),
      phone: new FormControl(null, Validators.required),
      address: new FormControl(null, Validators.required)
    });
    await this.FetchModels();
    await this.GetDealerModel();
    this.spinner.hide();
  }

  async FetchModels() {
    await this.roleService.apiRolesListRolesEmployeesGet().toPromise().then(response => {
      this.roles = response.list;
    }, error => {
      Swal.fire({
        title: 'Error!. ' + error,
        icon: 'error',
        showConfirmButton: false,
        timer: 2000,
        position: 'top-end'
      });
    });
    let params: ListStateRQ = {
        type: 1
    }
    await this.stateService.apiStateListGet(params).toPromise().then(response => {
      this.states = response.list;
    }, error => {
      Swal.fire({
        title: 'Error!. ' + error,
        icon: 'error',
        showConfirmButton: false,
        timer: 2000,
        position: 'top-end'
      });
    });
  }

  NumberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;
  }

  async GetDealerModel(): Promise<void> {
    if (this.isEditMode) {
      this.dealerForm.get('password').setValidators(null);
      const param: GetDealerModelRQ = {
        id: parseInt(this.dealerId, 10)
      };
      await this.dealerService.apiDealerGetPost(param).toPromise().then(async res => {
        await this.GetCitiesByStateId(res.stateId);
        this.dealerForm.setValue({
          roleId: res.roleId,
          stateId: res.stateId,
          cityId: res.cityId,
          name: res.userName,
          userName: res.userUserName,
          password: null,
          email: res.userEmail,
          phone: res.userPhone,
          address: res.address
        });
        this.dealerForm.updateValueAndValidity();
      }, error => {
        Swal.fire({
          title: 'Error!. ' + error,
          icon: 'error',
          showConfirmButton: false,
          timer: 2000,
          position: 'top-end'
        });
      });
    }
  }

  OnStateChange() {       
      this.spinner.show();
      this.fd.cityId.setValue(null);
      this.fd.cityId.updateValueAndValidity();
      if(this.dealerForm.get('stateId').value !== null){
      const param: ListCityByStateRQ = {
        stateId: this.dealerForm.get('stateId').value
      };
      this.cityService.apiCityListByStatePost(param).subscribe(res => {
        this.cities = res.list;
        this.dealerForm.get('cityId').enable();
        this.spinner.hide();
      }, error => {
        Swal.fire({
          title: 'Error!. ' + error,
          icon: 'error',
          showConfirmButton: false,
          timer: 2000,
          position: 'top-end'
        });
        this.spinner.hide();
      });
    }    
    else {
      this.cities = [];
      this.spinner.hide();
    }
  }

  async GetCitiesByStateId(stateId: number) {
    const param: ListCityByStateRQ = {
      stateId
    };
    this.dealerForm.get('cityId').disable();
    this.dealerForm.get('cityId').setValue(null);
    await this.cityService.apiCityListByStatePost(param).toPromise().then(res => {
      this.cities = res.list;
      this.dealerForm.get('cityId').enable();
    }, error => {
      Swal.fire({
        title: 'Error!. ' + error,
        icon: 'error',
        showConfirmButton: false,
        timer: 2000,
        position: 'top-end'
      });
    });
    this.dealerForm.get('cityId').updateValueAndValidity();
  }

  get fd() {
    return this.dealerForm.controls;
  }

  Back(): void {
    this.location.back();
  }

  Create() {
    this.spinner.show();
    const city = this.cities.find(c => c.id === this.fd.cityId.value);
    const state = this.states.find(s => s.id === this.fd.stateId.value);
    if (this.isEditMode) {
      const param: UpdateDealerRQ = this.dealerForm.value;
      param.phone = param.phone.toString();
      param.location = state.name + '/' + city.name;
      param.dealerId = parseInt(this.dealerId, 10);
      this.dealerService.apiDealerUpdatePost(param).subscribe(res => {
        Swal.fire({
          title: 'Actualizado Exitosamente.',
          icon: 'success',
          showConfirmButton: false,
          timer: 2000,
          position: 'top-end'
        });
        setTimeout(() => {
          this.router.navigate(['/pages/dealers']);
        }, 2010);        
        this.spinner.hide();
      }, error => {
        Swal.fire({
          title: 'Error!. ' + error,
          icon: 'error',
          showConfirmButton: false,
          timer: 2000,
          position: 'top-end'
        });
        this.spinner.hide();
      });
    } else {
      const param: AddDealerRQ = this.dealerForm.value;
      param.phone = param.phone.toString();
      param.location = state.name + '/' + city.name;
      this.dealerService.apiDealerAddPost(param).subscribe(res => {
        Swal.fire({
          title: 'Creado Exitosamente.',
          icon: 'success',
          showConfirmButton: false,
          timer: 2000,
          position: 'top-end'
        });
        setTimeout(() => {
          this.router.navigate(['/pages/dealers']);
        }, 2010);         
        this.spinner.hide();
      }, error => {
        Swal.fire({
          title: 'Error!. ' + error,
          icon: 'error',
          showConfirmButton: false,
          timer: 2000,
          position: 'top-end'
        });
        this.spinner.hide();
      });
    }
  }

  Cancel(): void {
    this.location.back();
  }
}
